export default "__VITE_ASSET__CbPMcObd__"